import { Action, createReducer, on } from "@ngrx/store";

import * as ProductGroupActionTypes from "../../actions/productGroups/productGroup.actions";
import * as PartiesActionTypes from "../../actions/parties/parties.actions";

import { ColumnSorterInfo } from "src/app/models/custom-table/custom-table.model";
import { CategoryDTO } from "src/app/models/Categories/categoryDTO";
import { PropertyDTO } from "src/app/models/Properties/propertyDTO";

export interface ProductGroupState {
  isLoading: boolean;
  created: boolean;
  productGroup: any;
  productGroupList: any[];
  productGroupExcelList: any[];
  productGroupTotal: number;
  productGroupTableConfig: ColumnSorterInfo[];
  categories: CategoryDTO[];
  properties: PropertyDTO[];
}

export const initialState: ProductGroupState = {
  isLoading: false,
  created: false,
  productGroup: null,
  productGroupExcelList: null,
  productGroupList: null,
  productGroupTotal: null,
  productGroupTableConfig: null,
  categories: null,
  properties: null,
};

const productGroupReducer = createReducer(
  initialState,
  on(ProductGroupActionTypes.resetProductGroupsState, () => initialState),
  on(ProductGroupActionTypes.resetProductGroupState, (state) => {
    return {
      ...state,
      productGroup: null,
    };
  }),
  on(
    ProductGroupActionTypes.getProductGroupList,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        options: options,
        isLoading: true,
      } as ProductGroupState)
  ),
  on(ProductGroupActionTypes.loadProductGroupList, (state, { response }) => {
    return {
      ...state,
      productGroupList: (response as any)?.result?.items
        ? (response as any)?.result?.items
        : undefined,
      isLoading: false,
      error: null,
      productGroupTotal: (response as any)?.result?.size
        ? (response as any)?.result?.size
        : 0,
    };
  }),
  on(
    ProductGroupActionTypes.getExcelProductGroupList,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        options: options,
        isLoading: true,
      } as ProductGroupState)
  ),
  on(
    ProductGroupActionTypes.loadExcelProductGroupList,
    (state, { response }) => {
      return {
        ...state,
        productGroupExcelList: (response as any)?.result?.items
          ? (response as any)?.result?.items
          : undefined,
        isLoading: false,
        error: null,
      };
    }
  ),
  on(
    ProductGroupActionTypes.getProductGroupTableConfig, 
    (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(
    ProductGroupActionTypes.loadProductGroupTableConfig,
    (state, { response }) => {
      return {
        ...state,
        productGroupTableConfig:
          (response as any)?.result?.value?.tableColumnInfo ?? undefined,
      };
    }
  ),
  on(ProductGroupActionTypes.saveProductGroupTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(
    ProductGroupActionTypes.getProductGroup,
    (state, { code }) =>
      ({
        ...state,
        error: null,
        code: code,
        created: false,
        isLoading: true,
      } as ProductGroupState)
  ),
  on(ProductGroupActionTypes.loadProductGroup, (state, { response }) => {
    return {
      ...state,
      productGroup: (response as any).result
        ? (response as any).result
        : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(ProductGroupActionTypes.resetProductGroupsState, (state) => {
    return {
      ...state,
      productGroupList: null,
      error: null,
    };
  }),
  on(ProductGroupActionTypes.loadCategoriesByUsage, (state, { response }) => {
    return {
      ...state,
      categories: (response as any)?.result?.items || [],
      error: null,
    };
  }),
  on(ProductGroupActionTypes.loadPropertiesByUsage, (state, { response }) => {
    return {
      ...state,
      properties: (response as any)?.result?.items || [],
      error: null,
    };
  }),
  on(ProductGroupActionTypes.createProductGroup, (state) => {
    return {
      ...state,
    };
  }),
  on(ProductGroupActionTypes.resetCreation, (state) => {
    return {
      ...state,
      created: true,
    };
  }),
  on(ProductGroupActionTypes.updateProductGroup, (state) => {
    return {
      ...state,
    };
  }),
  on(ProductGroupActionTypes.setLoadingEndState, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  })
);
export function reducer(state: ProductGroupState | undefined, action: Action) {
  return productGroupReducer(state, action);
}
